// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/view-design/dist/styles/iview.css
// module id = 25
// module chunks = 2